import LectureBlock from "./LectureBlock";

export default LectureBlock;